   import { FETCH_SETTINGS, SET_CREDITS, UPDATE_SETTINGS, SETTINGS_ERROR, SETTING_LOADING } from './constants';

   const initialState = {
     settings: {
        maintenance: false,
        commission: '',
        islandDeliveryFee: '',
        mainlandDeliveryFee: '',
        earningControl: '',
        fixedDays: [],
        hours: null,
        whatsappUrl: null
     },
     error: null,
     isLoading: false,
     credits: null,
   };

export default function settingsReducer(state = initialState, action) {
  switch (action.type) {
    case SET_CREDITS:
      return {
        ...state,
        credits: action.payload
      };
    case SETTING_LOADING:
      return {
        ...state,
        isLoading: action.payload
    };
    case FETCH_SETTINGS:
      return { ...state, settings: action.payload, error: null };
    case UPDATE_SETTINGS:
      return { ...state, settings: action.payload, error: null };
    case SETTINGS_ERROR:
      return { ...state, error: action.payload };
    default:
      return state;
    }
}
